import { useState, useEffect } from "react";
import apiRequest from "../../../../../utils/ApiRequest/apiRequest.js";
import config from "config";
import ToastHtmlComponent from "../../../../Reusable/ToastHtmlComponent/ToastHtmlComponent.js";
import WarningMailsModal from "./Modals/WarningMailsModal.js";
import encodeTags from "utils/encodeTagsFunc.ts";
import Form, { searchKeyInObject } from "../../../../Reusable/Form/Form.js";
import { useContent } from "../../../../../contexts/contentContext/contentContext.js";
import { useToasts } from "react-toast-notifications";
import { useModal } from "../../../../../contexts/modalContext/modalContext.js";

const AccountDetails = ({ userData, countries, formFields, occupations }) => {
  const { setModal } = useModal();
  const { addToast } = useToasts();
  const { getTextByKey } = useContent();
  const [userDetails, setuserDetails] = useState(userData);

  const [emailAddress, setEmailAddress] = useState(userData?.UserName);
  //convert the gender bool to string
  const checkUserGender = (gender) => {
    if (gender) {
      return "male";
    }
    return "female";
  };

  //convert gender string to bool
  const checkGenderToAPI = (gender) => {
    if (gender === "male") {
      return true;
    }
    return false;
  };

  const handleCheckIfEmailTaken = async (email) => {
    const parameters = {
      email,
    };

    const response = await apiRequest("Users", "DoesEmailExists", parameters);

    if (response.status === "success") {
      if (response.data) {
        addToast(getTextByKey("profile-user-details-email-taken"), {
          appearance: "error",
        });
      }
    } else {
      let errText = getTextByKey("api-error");
      errText = errText.replace("#ERRORNUM#", 999);
      errText = errText.replace("#SYSMAIL#", "contact-us");
      errText = errText.replace("#SYSMAIL#", config.supportmail);
      errText = errText.replace("#SYSMAIL#", "contact-us");
      addToast(<ToastHtmlComponent htmlStr={errText} />, {
        appearance: "error",
      });
    }

    return !!response?.data;
  };

  //Update Details
  const handleDetailsFormSubmit = async (body) => {
    if (countries && body.TypeSelectList) {
      const countryObj = countries.find(
        (item) => item.value === body.TypeSelectList
      );
      const countryValue = countryObj.constKey || null;
      body.UserCountry = countryValue;
    }

    const newBody = {};
    Object.entries(body).forEach(([key, value]) => {
      newBody[key] = encodeTags(value);
    });
    newBody.UserGender = checkGenderToAPI(body.UserGender);

    if (body.UserEmail !== userData.UserName) {
      const isTaken = await handleCheckIfEmailTaken(body.UserEmail);

      if (!isTaken) {
        setEmailAddress(body.UserEmail);
        setModal(() => (
          <WarningMailsModal
            userDetails={userDetails}
            userData={userData}
            newBody={newBody}
            setEmailAddress={setEmailAddress}
          />
        ));
        return { status: "success", data: null };
      }
    } else {
      return updateUser(newBody);
    }
  };

  //update details post request
  const updateUser = async (body) => {
    // body.captchaServiceName = "cloudflare";

    const response = await apiRequest(
      "Users",
      "ReactUpdateUserDetailes",
      body,
      "POST"
    );
    if (response.status === "success") {
      if (response.data.IsSuccess) {
        let tempUser = body;
        tempUser.UserBirthday = body.UserBirthdate
          ? new Date(body.UserBirthdate)
          : "";
        setuserDetails(tempUser);
        addToast(getTextByKey("update-details-success"), {
          appearance: "success",
        });
      } else {
        if (response.data.IsChangedEmail) {
          addToast(getTextByKey("profileuserdetails-email-taken"), {
            appearance: "error",
          });
        }
      }
    }
    return response;
  };

  return userData && countries.length > 0 && occupations.length > 0 ? (
    <div className="left-area">
      <Form
        fieldsProps={{
          field: "square",
        }}
        buttonProps={{ buttonsSize: "small" }}
        submitProps={{
          title: getTextByKey("profileuserdetails-update-details-btn"),
        }}
        fields={formFields}
        defaultValuesObj={{
          UserFirstName: userDetails.UserFirstName,
          UserLastName: userDetails.UserLastName,
          UserEmail: emailAddress,
          UserPhone: userDetails.UserPhone ? userDetails.UserPhone : "",
          UserBirthdate: userDetails.UserBirthday
            ? new Date(userDetails.UserBirthday)
            : "",
        }}
        defaultSelectObj={{
          UserOccupation:
            userDetails.UserOccupation === null
              ? {
                  constKey: searchKeyInObject(occupations, "-1"),
                  value: "-1",
                }
              : {
                  constKey: searchKeyInObject(
                    occupations,
                    userDetails.UserOccupation
                  ),
                  value: userDetails.UserOccupation,
                },
          UserGender: { value: checkUserGender(userDetails.UserGender) },
        }}
        onSubmit={handleDetailsFormSubmit}
        // captchaProvider="cloudflare"
        // cloudflareActionName="updateUserDetails"
      ></Form>
    </div>
  ) : null;
};

export default AccountDetails;
